/* ARRAY - product page. Bound by delegation on document: an inline script
   inside a Horizon section renders but never binds.

   THE MAIN IMAGE FOLLOWS THE PICK. Choosing a shade swaps the stage to that
   variant's own photo and lights up the matching thumbnail - that is the whole
   point of a swatch. It only stays put when the chosen variant has no photo of
   its own (multi-option bundles usually do not), because jumping to an
   unrelated image is worse than leaving the one on screen.

   BUT NOT ON FIRST LOAD, unless the URL names a variant. Most variant photos
   in this catalogue are swatch SMEARS rather than packshots, so syncing on
   load opened the page on a brown smear instead of the hero bottle. A ?variant=
   link is an explicit request for that shade and is honoured; a plain visit
   keeps the product's featured image.

   An even earlier version only moved the image when the one on screen was
   already a swatch. That was scaffolding for a decorative smear layer the
   client has since had removed, and it left the stage showing a red bottle
   while ROSE ENVY was selected.

   THE PICKER IS PER-OPTION, NOT PER-VARIANT. An earlier build hung the variant
   id on each swatch, which only works for single-option products; a two-option
   bundle had no picker at all and Add to Bag used whatever came first. Now the
   page holds `chosen` - one value per option - and resolves a variant from it.
   Clicking a value keeps that value and, if the resulting combination is not
   for sale, slides the OTHER options to the nearest combination that is, so a
   shopper can never dead-end on a page.

   THE SMEAR LAYER IS OFF (see templates/product.json) and the stage shows one
   image. syncSmear survives so the layer still behaves if it is switched back
   on, but it does nothing while no .pdp-smear element is rendered.

   WHAT THE BAR MEASURES. The bar is cosmetic - no discount or shipping rule
   exists behind it - but the number it shows is real: the live cart subtotal
   from /cart.js plus whatever is configured on this page right now.

   THE ADD SPEAKS HORIZON. It posts to /cart/add.js with the drawer's section
   ids and dispatches cart:update with the same detail shape as the theme's own
   product form, so the drawer re-renders and the icon count updates.

   THE STEPPER STOPS AT THE STOCK (12 Oct 2026 site check). A tracked variant
   with N left caps the quantity at N. Before, a shopper could pick 2 of the
   last 1: Shopify answered 422 but still put 1 in the cart, and because the
   error path never told the drawer, the bag kept saying "empty" until a
   reload. Untracked / keep-selling variants report 0 or less and keep the
   normal cap of QTY_MAX. If an add is still refused (e.g. the rest is already
   in the bag), refreshCart() re-reads the cart and re-renders the drawer with
   the real total - sent with a non product-form source, because cart-icon.js
   ADDS itemCount for product-form updates but SETS it for anything else.

   SOLD-OUT VALUES ARE REALLY DISABLED in the markup. pickOption still checks,
   because a disabled control must never be selectable by any route. */
(function () {
  if (window.__bdPdpBound) return;
  window.__bdPdpBound = true;

  var ROOT = '[data-pdp-root]';
  var QTY_MAX = 10;

  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return root.querySelectorAll(sel); }
  function parseJSON(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function keyOf(src) { return src ? src.split('?')[0].split('/').pop() : ''; }
  function sized(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  /* money: cents -> string via the shop's own format ({{amount}} etc) */
  function money(root, cents) {
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var n = (cents / 100);
    var parts = n.toFixed(2).split('.');
    var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_with_comma_separator}}', withSep.replace(/,/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals}}', Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount}}', withSep + '.' + parts[1]);
    return out.replace(/<[^>]+>/g, '');
  }
  function moneyShort(root, cents) { return money(root, cents).replace(/\.00(?!\d)/, ''); }

  /* ---------- state ---------- */
  function state(root) {
    if (root.__st) return root.__st;
    var variants = parseJSON(q(root, '[data-pdp-variants]')) || [];
    var ritual = parseJSON(q(root, '[data-pdp-ritual]')) || [];
    var addBtn = q(root, '[data-pdp-add]');
    var vid = addBtn ? parseInt(addBtn.getAttribute('data-vid'), 10) : 0;
    var card = q(root, '.pdp-card.is-on');
    var start = null;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === vid) start = variants[i];
    if (!start) start = variants[0] || null;
    root.__st = {
      variants: variants,
      ritual: ritual,
      vid: start ? start.id : 0,
      chosen: start ? (start.options || []).slice() : [],
      mode: card && card.getAttribute('data-pdp-card') === 'ritual' && ritual.length ? 'ritual' : 'single',
      qty: 1,
      cart: 0,
      t1: parseInt(root.getAttribute('data-t1'), 10) || 0,
      t2: parseInt(root.getAttribute('data-t2'), 10) || 0,
      low: parseInt(root.getAttribute('data-low'), 10) || 0,
      follows: root.getAttribute('data-smear-shade') === '1'
    };
    return root.__st;
  }

  /* the variant whose every option equals the current choice */
  function match(st, chosen) {
    for (var i = 0; i < st.variants.length; i++) {
      var o = st.variants[i].options || [];
      var ok = true;
      for (var j = 0; j < chosen.length; j++) if (o[j] !== chosen[j]) { ok = false; break; }
      if (ok) return st.variants[i];
    }
    return null;
  }
  /* nearest FOR SALE variant that keeps the value just clicked */
  function nearest(st, chosen, i) {
    var best = null, bestScore = -1;
    for (var k = 0; k < st.variants.length; k++) {
      var vv = st.variants[k];
      if (!vv.available) continue;
      var o = vv.options || [];
      if (o[i] !== chosen[i]) continue;
      var score = 0;
      for (var j = 0; j < chosen.length; j++) if (j !== i && o[j] === chosen[j]) score++;
      if (score > bestScore) { bestScore = score; best = vv; }
    }
    return best;
  }
  function variant(st) { return match(st, st.chosen) || null; }

  /* filenames that ARE variant photos - i.e. already a swatch smear */
  function swatchKeys(st) {
    if (st.__keys) return st.__keys;
    var set = {};
    for (var i = 0; i < st.variants.length; i++) {
      var im = st.variants[i].featured_image;
      if (im && im.src) set[keyOf(im.src)] = true;
    }
    st.__keys = set;
    return set;
  }
  function isSwatch(st, src) { return !!swatchKeys(st)[keyOf(src)]; }

  function ritualVariant(st) {
    var v = variant(st);
    if (!v || !st.ritual.length) return null;
    var shade = (v.option1 || v.title || '').toLowerCase();
    var same = null, any = null, first = null;
    for (var i = 0; i < st.ritual.length; i++) {
      var r = st.ritual[i];
      if (!r.available) continue;
      if (!first) first = r;
      var o1 = (r.option1 || '').toLowerCase(), o2 = (r.option2 || '').toLowerCase();
      if (o1 === shade && o2 === shade && !same) same = r;
      if (o1 === shade && !any) any = r;
    }
    return same || any || first;
  }
  function selection(st) {
    if (st.mode === 'ritual') {
      var r = ritualVariant(st);
      return r ? { id: r.id, price: r.price, available: true } : { id: 0, price: 0, available: false };
    }
    var v = variant(st);
    return v ? { id: v.id, price: v.price, available: !!v.available } : { id: 0, price: 0, available: false };
  }

  /* most that can be added: the stock of a tracked variant, else QTY_MAX */
  function maxQty(root) {
    var st = state(root);
    if (st.mode === 'ritual') return QTY_MAX;
    var v = variant(st);
    var inv = (v && typeof v.inventory_quantity === 'number') ? v.inventory_quantity : 0;
    return inv > 0 ? Math.min(QTY_MAX, inv) : QTY_MAX;
  }
  /* keep the stepper inside 1..max (the max moves when the variant changes) */
  function syncQty(root) {
    var st = state(root);
    var max = maxQty(root);
    if (st.qty > max) st.qty = max;
    if (st.qty < 1) st.qty = 1;
    var el = q(root, '[data-pdp-n]');
    if (el) el.textContent = String(st.qty);
    var minus = q(root, '[data-pdp-step="-1"]'), plus = q(root, '[data-pdp-step="1"]');
    if (minus) minus.disabled = st.qty <= 1;
    if (plus) plus.disabled = st.qty >= max;
  }

  /* ---------- stage ---------- */
  function syncSmear(root) {
    var st = state(root);
    var smear = q(root, '[data-pdp-smear]');
    var main = q(root, '[data-pdp-main]');
    if (!smear || !main) return;
    smear.classList.toggle('is-off', isSwatch(st, main.getAttribute('src')));
  }

  /* ---------- paint ---------- */
  function paintOptions(root) {
    var st = state(root);
    var rows = qa(root, '[data-pdp-opt]');
    for (var r = 0; r < rows.length; r++) {
      var i = parseInt(rows[r].getAttribute('data-pdp-opt'), 10);
      var btns = rows[r].querySelectorAll('[data-pdp-sw]');
      for (var b = 0; b < btns.length; b++) {
        var on = btns[b].getAttribute('data-pdp-val') === st.chosen[i];
        btns[b].classList.toggle('is-on', on);
        btns[b].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      var label = q(root, '[data-pdp-opt-name="' + i + '"]');
      if (label) label.textContent = (st.chosen[i] || '').toUpperCase();
    }
  }

  function paint(root) {
    var st = state(root);
    syncQty(root);
    var v = variant(st);
    var sel = selection(st);

    var price = q(root, '[data-pdp-price]');
    if (price && v) price.textContent = money(root, v.price);
    var sp = q(root, '[data-pdp-card-single-price]');
    if (sp && v) sp.textContent = money(root, v.price);

    var add = q(root, '[data-pdp-add]');
    if (add) {
      add.setAttribute('data-vid', String(sel.id || ''));
      add.disabled = !sel.available;
      var t = q(add, '[data-pdp-add-t]');
      if (t) t.textContent = sel.available ? (add.getAttribute('data-label') || t.textContent) : (add.getAttribute('data-soldout') || 'SOLD OUT');
      var pEl = q(add, '[data-pdp-add-p]');
      if (pEl) pEl.textContent = money(root, sel.price * st.qty);
    }

    var low = q(root, '[data-pdp-low]');
    if (low) {
      var inv = (v && typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null;
      low.hidden = !(v && v.available && inv !== null && inv > 0 && inv <= st.low);
    }

    paintBar(root);
  }

  function paintBar(root) {
    var st = state(root);
    var sel = selection(st);
    var value = st.cart + (sel.available ? sel.price * st.qty : 0);
    var fill = q(root, '[data-pdp-fill]');
    var copy = q(root, '[data-pdp-bar-copy]');
    var m1 = q(root, '[data-pdp-mark-1]');
    var m2 = q(root, '[data-pdp-mark-2]');
    if (!fill || !st.t2) return;
    fill.style.width = Math.max(0, Math.min(100, value / st.t2 * 100)) + '%';
    fill.style.setProperty('--m1', (st.t1 / st.t2 * 100) + '%');
    fill.classList.toggle('is-2', value >= st.t1 && st.t1 < st.t2);
    if (m1) m1.classList.toggle('is-hit', value >= st.t1);
    if (m2) m2.classList.toggle('is-hit', value >= st.t2);
    if (copy) {
      var tpl;
      if (value < st.t1) tpl = root.getAttribute('data-copy-1');
      else if (value < st.t2) tpl = root.getAttribute('data-copy-2');
      else tpl = root.getAttribute('data-copy-3');
      var need = value < st.t1 ? st.t1 - value : (value < st.t2 ? st.t2 - value : 0);
      copy.textContent = (tpl || '').replace('{amount}', moneyShort(root, need));
    }
  }

  function loadCart(root) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { state(root).cart = c.items_subtotal_price || 0; paintBar(root); })
      .catch(function () {});
  }

  /* ---------- gallery ---------- */
  function showThumb(root, btn) {
    if (!btn) return;
    var all = qa(root, '[data-pdp-thumb]');
    for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-on', all[i] === btn);
    if (btn.scrollIntoView) { try { btn.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    var main = q(root, '[data-pdp-main]');
    var stage = q(root, '[data-pdp-stage]');
    var src = btn.getAttribute('data-src');
    if (main && src && main.getAttribute('src') !== src) {
      if (stage) stage.classList.add('is-swap');
      var img = new Image();
      img.onload = function () { main.setAttribute('src', src); if (stage) stage.classList.remove('is-swap'); syncSmear(root); };
      img.onerror = function () { if (stage) stage.classList.remove('is-swap'); };
      img.src = src;
    } else {
      syncSmear(root);
    }
    var now = q(root, '[data-pdp-now]');
    if (now) { var n = parseInt(btn.getAttribute('data-pdp-thumb'), 10) + 1; now.textContent = (n < 10 ? '0' : '') + n; }
  }
  function thumbForVariant(root, v) {
    if (!v || !v.featured_image || !v.featured_image.src) return null;
    var key = keyOf(v.featured_image.src);
    var all = qa(root, '[data-pdp-thumb]');
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-key') === key) return all[i];
    return null;
  }
  /* move the stage to the selected variant's own photo, if it has one */
  function showVariant(root, v) {
    var t = thumbForVariant(root, v);
    if (t) showThumb(root, t);
    else syncSmear(root);
  }

  /* ---------- picks ---------- */
  function pickOption(root, btn) {
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var st = state(root);
    var row = btn.closest('[data-pdp-opt]');
    if (!row) return;
    var i = parseInt(row.getAttribute('data-pdp-opt'), 10);
    var next = st.chosen.slice();
    next[i] = btn.getAttribute('data-pdp-val');

    var v = match(st, next);
    if (!v || !v.available) {
      var alt = nearest(st, next, i);
      if (alt) v = alt;
    }
    if (v) { st.chosen = (v.options || []).slice(); st.vid = v.id; }
    else { st.chosen = next; st.vid = 0; }

    paintOptions(root);

    var vsrc = (v && v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
    var smear = q(root, '[data-pdp-smear]');
    if (smear && st.follows && vsrc) smear.setAttribute('src', sized(vsrc, 1200));

    showVariant(root, v);

    if (v && window.history && history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
    paint(root);
  }
  function pickCard(root, btn) {
    var st = state(root);
    st.mode = btn.getAttribute('data-pdp-card') === 'ritual' ? 'ritual' : 'single';
    var all = qa(root, '[data-pdp-card]');
    for (var i = 0; i < all.length; i++) {
      var on = all[i] === btn;
      all[i].classList.toggle('is-on', on);
      all[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
    paint(root);
  }
  function stepQty(root, btn) {
    var st = state(root);
    st.qty = Math.max(1, Math.min(maxQty(root), st.qty + (parseInt(btn.getAttribute('data-pdp-step'), 10) || 0)));
    paint(root);
  }

  /* ---------- add ---------- */
  function sectionIds() {
    var ids = [];
    var comps = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < comps.length; i++) if (comps[i].dataset && comps[i].dataset.sectionId) ids.push(comps[i].dataset.sectionId);
    return ids;
  }
  function announce(root, qty, sections) {
    var ev;
    try {
      ev = new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: 'beyondads-pdp', data: { source: 'product-form-component', itemCount: qty, productId: root.getAttribute('data-product-id'), sections: sections || {} } } });
    } catch (e) { return; }
    document.dispatchEvent(ev);
  }
  /* after a refused add: re-read the cart and redraw the drawer with the REAL total
     (a non product-form source, so the icon SETS the count instead of adding to it) */
  function refreshCart(root) {
    var ids = sectionIds();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var get = ids.length
          ? fetch(window.location.pathname + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
          : Promise.resolve({});
        return get.then(function (sections) {
          try {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'beyondads-pdp-refresh', data: { source: 'beyondads-pdp-refresh', itemCount: cart.item_count || 0, productId: root.getAttribute('data-product-id'), sections: sections || {} } } }));
          } catch (e) {}
          loadCart(root);
        });
      })
      .catch(function () { loadCart(root); });
  }
  function add(root, btn, id, qty, labelSel) {
    if (!id || btn.disabled || btn.__busy) return;
    var label = labelSel ? q(btn, labelSel) : null;
    var was = label ? label.textContent : '';
    btn.__busy = true;
    btn.classList.add('is-busy');
    var body = { items: [{ id: id, quantity: qty }] };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res || res.status >= 400 || res.errors) {
          if (label) label.textContent = qty > 1 ? 'NO MORE IN STOCK' : 'NOT AVAILABLE';
          refreshCart(root);
          setTimeout(function () { if (label) label.textContent = was; btn.__busy = false; }, 2200);
          return;
        }
        btn.classList.add('is-done');
        if (label) label.textContent = 'ADDED TO BAG';
        announce(root, qty, res.sections);
        loadCart(root);
        setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = was; btn.__busy = false; }, 1800);
      })
      .catch(function () { btn.classList.remove('is-busy'); btn.__busy = false; });
  }

  /* ---------- zoom ---------- */
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.addEventListener('mousemove', function (e) {
    if (!fine || !e.target.closest) return;
    var stage = e.target.closest('[data-pdp-stage]');
    if (!stage) return;
    var r = stage.getBoundingClientRect();
    stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
    stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
    stage.classList.add('is-zoom');
  });
  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var stage = e.target.closest('[data-pdp-stage]');
    if (stage && !stage.contains(e.relatedTarget)) stage.classList.remove('is-zoom');
  });

  /* ---------- delegation ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var root = e.target.closest(ROOT);
    if (!root) return;

    var th = e.target.closest('[data-pdp-thumb]');
    if (th) { e.preventDefault(); showThumb(root, th); return; }
    var sw = e.target.closest('[data-pdp-sw]');
    if (sw) { e.preventDefault(); pickOption(root, sw); return; }
    var card = e.target.closest('[data-pdp-card]');
    if (card) { e.preventDefault(); pickCard(root, card); return; }
    var st = e.target.closest('[data-pdp-step]');
    if (st) { e.preventDefault(); stepQty(root, st); return; }
    var up = e.target.closest('[data-pdp-upadd]');
    if (up) { e.preventDefault(); add(root, up, parseInt(up.getAttribute('data-vid'), 10), 1, null); return; }
    var addBtn = e.target.closest('[data-pdp-add]');
    if (addBtn) {
      e.preventDefault();
      add(root, addBtn, parseInt(addBtn.getAttribute('data-vid'), 10), state(root).qty, '[data-pdp-add-t]');
    }
  });

  document.addEventListener('cart:update', function () {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) loadCart(roots[i]);
  });

  function init(root) {
    var st = state(root);
    var add = q(root, '[data-pdp-add]');
    if (add) {
      var t = q(add, '[data-pdp-add-t]');
      if (t && !add.getAttribute('data-label') && !add.disabled) add.setAttribute('data-label', t.textContent);
      if (t && !add.getAttribute('data-soldout') && add.disabled) add.setAttribute('data-soldout', t.textContent);
      if (!add.getAttribute('data-label')) add.setAttribute('data-label', 'ADD TO BAG');
    }
    paintOptions(root);
    if (/[?&]variant=/.test(window.location.search)) showVariant(root, variant(st));
    else syncSmear(root);
    paint(root);
    loadCart(root);
  }
  function initAll() { var r = document.querySelectorAll(ROOT); for (var i = 0; i < r.length; i++) init(r[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
